import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router-dom";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors,
} from "@material-ui/core";
import { add_agency } from "../../../../api/API";
import ColorPicker from "material-ui-color-picker";

const useStyles = makeStyles((theme) => ({
  root: {},

  flexend: {
    justifyContent: "flex-end",
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
}));

export default function From(props) {
  const { profile, className, ...rest } = props;

  const classes = useStyles();

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [passwordError, setPasswordError] = useState({
    isError: false,
    message: "",
  });
  const [values, setValues] = useState({
    // firstName: profile.firstName,
    // lastName: profile.lastName,
    // email: profile.email,
    // phone: profile.phone,
    // state: profile.state,
    // country: profile.country,
    // isPublic: profile.isPublic,
    // canHire: profile.canHire
  });

  const history = useHistory();

  //   const checkPassword = (password) => {
  //     let check_length = new RegExp("(?=.{6,})");
  //     let check_number = new RegExp("(?=.*[0-9])");
  //     let check_special = new RegExp("(?:.*[!@#$%^&*()+'\"]+.*)");

  //     if (!check_length.test(password)) {
  //       setPasswordError({
  //         isError: true,
  //         message: "Password must be at least 6 characters or longer",
  //       });
  //       return false;
  //     }
  //     if (!check_number.test(password)) {
  //       setPasswordError({
  //         isError: true,
  //         message: "Password must be at contain at least 1 number",
  //       });
  //       return false;
  //     }
  //     if (!check_special.test(password)) {
  //       setPasswordError({
  //         isError: true,
  //         message: "Password must be at least 1 special character",
  //       });
  //       return false;
  //     }
  //     setPasswordError({
  //       isError: false,
  //       message: "All Good",
  //     });

  //     return true;
  //   };

  const positions = ["Superadmin", "Admin"];

  const handleChange = (event) => {
    event.persist();
    // if (event.target.name == "password") {
    //   checkPassword(event.target.value);
    // }
    if (event.target.name == "short_name" && event.target.value.length > 5) {
      return;
    }

    setValues({
      ...values,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    // event.preventDefault();
    // setOpenSnackbar(true);
    // history.push("/agency");

    event.preventDefault();
    // if (!checkPassword(values.password)) {
    //   return;
    // }

    // if (values.password != values.password2) {
    //   alert("Password do not match");
    //   return;
    // }
    // if (values.password == "") {
    //   alert("Please enter a password");
    //   return;
    // }
    const postparam = {
      username: values.email,
      //   password: values.password,
      name: values.name,
      //   email: values.email,
      short_name: values.short_name,
      contact: values.phone,
    };

    let data = await add_agency(postparam);
    if (data.status) {
      setOpenSnackbar(true);
      history.push("/agency");
    } else {
      alert(data.message);
    }
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <form onSubmit={handleSubmit}>
        <CardHeader title="Create New Agency" />
        <Divider />
        <CardContent>
          <Grid container spacing={4}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Short name"
                name="short_name"
                onChange={handleChange}
                required
                value={values.short_name}
                variant="outlined"
              />
            </Grid>
            {/* <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                onChange={handleChange}
                required
                value={values.email}
                variant="outlined"
              />
            </Grid> */}

            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Contact"
                name="phone"
                onChange={handleChange}
                type="text"
                value={values.phone}
                variant="outlined"
              />
            </Grid>
            {/* <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                onChange={handleChange}
                type="password"
                required
                value={values.password}
                variant="outlined"
                error={passwordError.isError}
                helperText={passwordError.message}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Confirm Password"
                name="password2"
                onChange={handleChange}
                type="password"
                required
                value={values.password2}
                variant="outlined"
              />
            </Grid> */}

            <Grid item md={6} xs={12}>
              {/* <TextField
                    fullWidth
                    label="Position"
                    name="position"
                    onChange={handleChange}
                    select
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{ native: true }}
                    required
                    value={values.position}
                    variant="outlined"
                    >
                {positions.map(position => (
                    <option
                        key={position}
                        value={position}
                    >
                        {position}
                    </option>
                ))}
                </TextField> */}
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions className={classes.flexend}>
          <Button
            variant="contained"
            style={{
              backgroundColor: "black",
            }}
            onClick={() => {
              history.goBack();
            }}
          >
            <CancelIcon className={classes.leftIcon} />
            Cancel
          </Button>
          <Button
            className={classes.saveButton}
            type="submit"
            variant="contained"
          >
            <SaveIcon className={classes.leftIcon} />
            Save Changes
          </Button>
        </CardActions>
      </form>
      {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
    </Card>
  );
}
